exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".btns {\n  margin-top: 2rem;\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n}\n\n.btns .btn-prev {\n  width: 200px;\n  border-radius: 5px;\n}\n\n.btns .btn-next {\n  width: 200px;\n  background-color: #ffe600;\n  border-color: #7f7e82;\n  border-radius: 5px;\n  font-weight: 600;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/pages/Pricing/NewPricing/step-input.style.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/resolve-url-loader/index.js!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/pages/Pricing/NewPricing/step-input.style.scss
// module chunks = 0